import { useNavigate } from "react-router-dom";
import MiscLandingContent from "shared/components/misc/MiscLandingContent.js";

/*interface PageHomeProps {
  props: object;
  flowUser: Object;
  assistantUser: Object;
  updateAssistantUser: Object;
  logout: Object;
  yScrollPosition: number;
}*/

const PageHome = ({ props, flowUser, assistantUser, updateAssistantUser, logout, yScrollPosition }) => {
  const navigate = useNavigate();

  return (
    <div id="PageHome" className="h-100">
      <MiscLandingContent />
    </div>
  );
};

export default PageHome;
